import React from "react";
import { Col, Row } from "react-bootstrap";
import { DiJavascript1, DiReact, DiNodejs, DiMongodb, DiGit } from "react-icons/di";
import { SiNextdotjs, SiFirebase } from "react-icons/si";
import './Techstack.css';
import { IoLogoFigma } from "react-icons/io5";
// import { Si365Datascience } from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb"
function Techstack() {
  return (
    <div>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <DiJavascript1 />
          <p>JavaScript</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiNodejs />
          <p>Node.js</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiReact />
          <p>React.js</p>
        </Col>
      </Row>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <DiMongodb />
          <p>MongoDB</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiNextdotjs />
          <p>Next.js</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiGit />
          <p>Git</p>
        </Col>
      </Row>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <SiFirebase />
          <p>Firebase</p>
        </Col>
       
       
        <Col xs={4} md={2} className="tech-icons">
        <TbBrandReactNative />
          <p>React Native</p>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
        <IoLogoFigma />
          <p>Figma</p>
        </Col> 
      
      </Row>
    </div>
  );
}

export default Techstack;